/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey created`)
};

const zh_hans1_login_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通行密钥已创建`)
};

const zh_hant1_login_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通行金鑰已建立`)
};

const fr_login_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey créée`)
};

const de_login_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey erstellt`)
};

const ja_login_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーを作成しました`)
};

const ko_login_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패스키가 생성되었습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_passkey_registered = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_passkey_registered(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_passkey_registered", locale)
	if (locale === "en") return en_login_passkey_registered(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_passkey_registered(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_passkey_registered(inputs)
	if (locale === "fr") return fr_login_passkey_registered(inputs)
	if (locale === "de") return de_login_passkey_registered(inputs)
	if (locale === "ja") return ja_login_passkey_registered(inputs)
	return ko_login_passkey_registered(inputs)
};